(() => {
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer(drawerEl) {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
  }

  function getItemData(itemEl) {
    const jsonEl = itemEl.querySelector('.stl-variants-json');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(itemEl) {
    const selected = {};
    itemEl.querySelectorAll('.stl-swatch.is-active').forEach((btn) => {
      const pos = btn.dataset.optionPosition;
      const value = btn.dataset.optionValue;
      if (pos) selected[pos] = value;
    });
    return selected;
  }

  function findMatchingVariant(itemEl) {
    const variants = getItemData(itemEl);
    const selected = getSelectedOptions(itemEl);

    if (!variants.length) return null;

    const optionCount = Math.max(
      ...variants.map((v) => (Array.isArray(v.options) ? v.options.length : 0)),
      0
    );

    for (const variant of variants) {
      let matches = true;

      for (let i = 1; i <= optionCount; i++) {
        if (selected[i] && variant.options[i - 1] !== selected[i]) {
          matches = false;
          break;
        }
      }

      if (matches) return variant;
    }

    return null;
  }

  function updateVariantId(itemEl, variant) {
    const input = itemEl.querySelector('.stl-variant-id');
    if (input && variant) input.value = variant.id;
  }

  function formatMoneyFromCents(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format((cents || 0) / 100);
  }

  function updatePrice(itemEl, variant) {
    const priceEl = itemEl.querySelector('.stl-item-price');
    if (priceEl && variant) {
      priceEl.textContent = formatMoneyFromCents(variant.price);
    }
  }

  function updateAddButton(itemEl, variant) {
    const btn = itemEl.querySelector('.stl-add-btn');
    if (!btn || !variant) return;

    if (variant.available) {
      btn.disabled = false;
      btn.classList.remove('is-soldout');
      btn.textContent = 'ADD TO CART';
    } else {
      btn.disabled = true;
      btn.classList.add('is-soldout');
      btn.textContent = 'SOLD OUT';
    }
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;

    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'ADDING...';
    } else {
      btn.textContent = btn.dataset.originalText || 'ADD TO CART';
    }
  }

  function flashAdded(btn) {
  const original = btn.dataset.originalText || 'ADD TO CART';
  btn.textContent = 'ADDED';
  btn.classList.add('is-added');

  setTimeout(() => {
    btn.textContent = original;
    btn.disabled = false;
    btn.classList.remove('is-added');
  }, 1000);
}

  async function addToCart(variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) {
      let message = 'Could not add to cart.';
      try {
        const err = await response.json();
        message = err.description || err.message || message;
      } catch (_) {}
      throw new Error(message);
    }

    return response.json();
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  function updateCartCount(count) {
    const selectors = [
      '[data-cart-count]',
      '.cart-count',
      '.cart-count-bubble',
      '#cart-icon-bubble',
      '[data-cart-bubble-count]'
    ];

    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (el.children.length === 0) {
          el.textContent = String(count);
        } else {
          const span = el.querySelector('span');
          if (span) {
            span.textContent = String(count);
          } else {
            el.textContent = String(count);
          }
        }

        el.classList.remove('hidden', 'is-hidden');
        el.removeAttribute('hidden');
      });
    });
  }

  async function rerenderCartDrawer() {
    const drawerSection = document.querySelector('[id^="shopify-section-cart-drawer"], [id^="shopify-section-cart-notification-drawer"]');
    if (!drawerSection) return false;

    const sectionId = drawerSection.id.replace('shopify-section-', '');
    if (!sectionId) return false;

    const res = await fetch(`/?sections=${encodeURIComponent(sectionId)}`, {
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) return false;

    const json = await res.json();
    const html = json[sectionId];
    if (!html) return false;

    drawerSection.innerHTML = html;
    return true;
  }

  async function refreshCartUi() {
    try {
      const cart = await getCart();
      updateCartCount(cart.item_count || 0);
      await rerenderCartDrawer();

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart }
        })
      );
    } catch (_) {}
  }

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.stl-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(trigger.getAttribute('data-stl-target'));
      return;
    }

    const closeBtn = e.target.closest('[data-stl-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer(closeBtn.closest('.stl-container'));
      return;
    }

    const swatch = e.target.closest('.stl-swatch');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();

      const itemEl = swatch.closest('[data-stl-item]');
      const position = swatch.dataset.optionPosition;
      if (!itemEl || !position) return;

      itemEl.querySelectorAll(`.stl-swatch[data-option-position="${position}"]`).forEach((btn) => {
        btn.classList.remove('is-active');
      });

      swatch.classList.add('is-active');

      const variant = findMatchingVariant(itemEl);
      if (variant) {
        updateVariantId(itemEl, variant);
        updatePrice(itemEl, variant);
        updateAddButton(itemEl, variant);
      }

      return;
    }

    const addBtn = e.target.closest('.stl-add-btn');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (addBtn.disabled || addBtn.classList.contains('is-soldout')) {
        return;
      }

      const itemEl = addBtn.closest('[data-stl-item]');
      if (!itemEl) return;

      const variantInput = itemEl.querySelector('.stl-variant-id');
      const variantId = variantInput ? variantInput.value : null;

      if (!variantId) {
        alert('Please select an option first.');
        return;
      }

      try {
        setLoading(addBtn, true);
        await addToCart(variantId);
        await refreshCartUi();
        setLoading(addBtn, false);
        flashAdded(addBtn);
      } catch (err) {
        setLoading(addBtn, false);
        alert(err.message || 'Could not add to cart.');
      }
    }
  }, true);
})();